declare namespace $ {

	export class $shm_ba_mention_stats_task extends $shm_mentionstat_task {
	}
	
}

//# sourceMappingURL=task.view.tree.d.ts.map